// 2_components/products_block_slider.js
// Turns every product block (except on listing pages) into a custom slider via
// window.NAT.utils.initializeSliderElement.

export function init() {
	initializeProductsBlockSliders();
}

function initializeProductsBlockSliders() {
	const allProductsBlocks = document.querySelectorAll(".products-block:not(.products-page)");
	if (allProductsBlocks && allProductsBlocks.length > 0) {
		allProductsBlocks.forEach((block) => {
			const productsBlockItems = block.querySelectorAll(".product");
			window.NAT.utils.initializeSliderElement(null, block, productsBlockItems, "products-slider", "img");
		});
		console.log(
			"initializeProductsBlockSliders: Sliders initialized for " + allProductsBlocks.length + " products blocks.",
		);
	}
}
